import { Button } from "antd";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import config from "../config/form.json";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getOrgsDetails } from "../services/httpCalls";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import {
  orgID,
  orgmode,
  editactive,
  notOps,
  orgaDetails,
  inwardPartner,
  hasInwardBank,
  newPartnerList,
  productSelection,
} from "../store/gloabalState";

// importing components
import CreateOrg from "./createOrg";
import Ubo from "../components/new-onboarding/ubo";
import CkycNew from "../components/new-onboarding/ckyc";
import CdocsNew from "../components/new-onboarding/cdocs";
import Products from "../components/new-onboarding/products";
import SoleDocs from "../components/new-onboarding/sole-docs";
import BasicInfo from "../components/new-onboarding/basic-info";
import OutwardDetails from "../components/new-onboarding/outward-details";
import InwardDetails from "../components/new-onboarding/inward-details";
import DirectorDetails from "../components/new-onboarding/director-details";
import SoleKyc from "../components/new-onboarding/sole-kyc";
import { getXflowProduct } from "../utils/get-xflow-product";
import InitialInvoice from "../components/new-onboarding/initial-invoice";
import { hasInwardBankMethod } from "../utils/has-inward-bank-method";
import { getAllPartners } from "../utils/get-all-partners";
import { getProductionSelectionType } from "../utils/onboarding/onboardingUtils";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const OnboardOrgNew = () => {
  // * string constants
  const INITIAL_INVOICE = "Initial Invoice";
  const OUTWARD_DETAILS = "Outward Details";

  // * local states
  const [value, setValue] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [orgDetails, setOrgDetails] = useRecoilState(orgaDetails);
  const [inwardPartnerState, setInwardPartnerState] =
    useRecoilState(inwardPartner);

  // * global states

  // * values
  const notOps_ = useRecoilValue(notOps);
  const hasInwardBankValue = useRecoilValue(hasInwardBank);
  const selectionValue = useRecoilValue(productSelection);
  const partnerState = useRecoilValue(inwardPartner);

  // * updater/setter
  const setHasInwardBank = useSetRecoilState(hasInwardBank);
  const setNewPartnerList = useSetRecoilState(newPartnerList);

  // * states
  const [mode, setMode] = useRecoilState(orgmode);
  const [orgId, setOrgId] = useRecoilState(orgID);
  const [editActive, setEditActive] = useRecoilState(editactive);

  // * constants/binders
  const navigate = useNavigate();
  const kycStages = [
    "PHONE_VERIFIED",
    "COMPANY_TYPE_ENTERED",
    "PAN_ENTERED",
    "DRAFT_CORPORATE_DETAILS",
    "BUSINESS_DESCRIPTION",
    "DRAFT_REGISTERED_ADDRESS",
    "DRAFT_BANK_DETAILS",
    "DRAFT_CORPORATE_DETAILS",
  ];

  const hasBdSubmittedOrgStatuses = [
    "SUBMITTED_BY_BD_AM",
    "DRAFT_SAVED_FOR_REVIEW_BY_OPS",
    "FINAL_SUBMISSION_DONE",
  ];

  const isModeView = mode === "view";
  const isModeEdit = mode === "edit";
  const isNotFreelancer = orgDetails?.companyType !== "FREELANCER";
  const isNotSoleProp = orgDetails?.companyType !== "SOLE_PRORIETOR";
  const { hasOnlyXflow } = getProductionSelectionType(
    selectionValue,
    partnerState,
    hasInwardBankValue
  );

  const handleTabChange = (e, value) => {
    if (isModeView) {
      if (e.currentTarget.innerText === "Inward Details" && value === 4) {
        handleChange(6);
      } else if (e.currentTarget.innerText === OUTWARD_DETAILS) {
        handleChange(7);
      } else if (e.currentTarget.innerText === INITIAL_INVOICE) {
        handleChange(8);
      } else {
        handleChange(value);
      }
    }
  };

  const handleChange = async (newValue) => {
    if (newValue === 5) {
      if (
        inwardPartnerState?.includes("payglocal") &&
        orgDetails?.companyType === "FREELANCER"
      ) {
        setValue(5);
        if (newValue === 2) {
          setRefresh(true);
        }
      } else {
        setValue(newValue);
        if (newValue === 2) {
          setRefresh(true);
        }
      }
    } else {
      setValue(newValue);
      if (newValue === 2) {
        setRefresh(true);
      }
    }
  };

  const handleNextButton = () => {
    if (value === 3) {
      handleChange(6);
    } else {
      if ((orgDetails?.isOptInward || orgDetails?.isOptOutward) && value < 6) {
        handleChange(value + 1);
      } else {
        navigate("/orgs");
      }
    }
  };

  const handleSubmitButton = () => {
    if (orgDetails?.isOptInward && orgDetails?.isOptOutward && value >= 7) {
      navigate("/orgs");
    } else if (
      orgDetails?.isOptInward &&
      orgDetails?.isOptOutward !== true &&
      value >= 6
    ) {
      navigate("/orgs");
    } else if (
      orgDetails?.isOptOutward &&
      orgDetails?.isOptInward !== true &&
      value >= 6
    ) {
      navigate("/orgs");
    } else {
      if (
        orgDetails?.isOptOutward &&
        orgDetails?.isOptInward !== true &&
        value === 5
      ) {
        handleChange(7);
      } else if (
        orgDetails?.isOptInward &&
        orgDetails?.isOptOutward !== true &&
        value === 5
      ) {
        handleChange(6);
      } else {
        handleChange(value + 1);
      }
    }
  };

  useEffect(() => {
    let url_ = window.location.pathname;
    url_ = url_.split("/");
    if (url_[1] === "orgdetails") {
      setMode("view");
      localStorage.setItem("orgId", url_[2]);
      setValue(1);
    } else if (url_[1] === "orgedit") {
      setMode("edit");
      localStorage.setItem("orgId", url_[2]);
    } else if (url_[1] === "onboardorg") {
      setMode("new");
      localStorage.removeItem("orgId");
      setValue(0);
    }
  }, []);

  useEffect(() => {
    let orgId = localStorage.getItem("orgId");
    setOrgId(orgId);
    if (orgId !== null) {
      getOrgsDetails(orgId).then((res) => {
        if (res) {
          setOrgDetails(res);
          setHasInwardBank(hasInwardBankMethod(res));
          getAllPartners(res, setNewPartnerList);
          if (res?.isOptInward || res?.inwardPayglocal || res?.inwardXflow) {
            if (res?.inwardPayglocal && !res?.inwardXflow) {
              setInwardPartnerState(["payglocal"]);
            }
            if (res?.inwardXflow && !res?.inwardPayglocal) {
              setInwardPartnerState(["xflow"]);
            }
            if (!res?.inwardXflow && !res?.inwardPayglocal) {
              setInwardPartnerState([]);
            }
            if (res?.inwardXflow && res?.inwardPayglocal) {
              setInwardPartnerState(["xflow", "payglocal"]);
            }
          } else {
            setInwardPartnerState([]);
          }
          if (res?.panNumber) {
            Cookies.set("pan", res?.panNumber);
          }
          if (res?.userList) {
            Cookies.set("userId", res?.userList[0].id);
          }
          if (!res.isOptOutward && !res.isOptInward) {
            setValue(1);
          } else if (kycStages.includes(res?.status)) {
            setValue(2);
          } else if (res.status === "DRAFT_CORPORATE_DOCS") {
            setValue(3);
          } else if (res.status === "DRAFT_AUTH_SIGNATORY") {
            setValue(4);
          } else if (res.status === "DRAFT_SHAREHOLDERS") {
            let currentStage = Cookies.get("currentStage");
            if (currentStage == 6 && res.isOptInward) {
              setValue(6);
            } else if (currentStage == 7 && res.isOptOutward) {
              setValue(7);
            } else {
              setValue(5);
            }
          } else if (res.status === "ACTIVE" || res.status === "NEXT_INVOICE") {
            setValue(1);
          }
          if (
            mode === "edit" &&
            (res.status === "ACTIVE" || res.status === "NEXT_INVOICE")
          ) {
            setEditActive(true);
          }
          if (
            mode === "edit" &&
            hasBdSubmittedOrgStatuses.includes(res?.accountSubmissionStatus)
          ) {
            setEditActive(true);
            setValue(1);
          }
          if (mode === "view") {
            setValue(1);
          }
        }
      });
    } else {
      setValue(0);
      setOrgDetails();
      setMode("new");
    }
  }, [mode, orgId]);

  useEffect(() => {
    if (refresh) {
      let orgId = localStorage.getItem("orgId");
      getOrgsDetails(orgId).then((res) => {
        if (res) {
          setHasInwardBank(hasInwardBankMethod(res));
          getAllPartners(res, setNewPartnerList);
          setOrgDetails(res);
          if (res?.isOptInward || res?.inwardPayglocal || res?.inwardXflow) {
            if (res?.inwardPayglocal && !res?.inwardXflow) {
              setInwardPartnerState(["payglocal"]);
            }
            if (res?.inwardXflow && !res?.inwardPayglocal) {
              setInwardPartnerState(["xflow"]);
            }
            if (!res?.inwardXflow && !res?.inwardPayglocal) {
              setInwardPartnerState([]);
            }
            if (res?.inwardXflow && res?.inwardPayglocal) {
              setInwardPartnerState(["xflow", "payglocal"]);
            }
          } else {
            setInwardPartnerState([]);
          }
        }
      });
    }
  }, [refresh, value]);

  return (
    <Box sx={{ padding: "1rem 0" }}>
      {isModeView ? (
        <Typography variant="h5">View Organisation Details</Typography>
      ) : isModeEdit ? (
        <Typography variant="h5">Edit Organisation Details</Typography>
      ) : (
        <Typography variant="h5">Create Organisation</Typography>
      )}
      <Box sx={{ width: "100%" }} className="tabs_content">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            className="tabs_wrap"
            value={value}
            aria-label="basic tabs example"
            onChange={(e, value) => handleTabChange(e, value)}
          >
            {Object.keys(config).map((key, index) => {
              const section = config[key][0];

              const isCompanyTypeAllowed = section.hasOwnProperty(
                "notCompanyType"
              )
                ? inwardPartnerState?.includes("payglocal")
                  ? true
                  : !section.notCompanyType.includes(orgDetails?.companyType)
                : true;
              const isProductInward =
                orgDetails && orgDetails?.isOptInward
                  ? section.product.includes("inward")
                  : true;
              const isProductOutward =
                orgDetails && orgDetails?.isOptOutward
                  ? section.product.includes("outward")
                  : true;
              const isBothProductSelected =
                orgDetails &&
                orgDetails?.isOptInward &&
                orgDetails?.isOptOutward;
              const isOpsAllowed = section.hasOwnProperty("ops")
                ? !notOps_
                : true;
              const isBD_CAllowed =
                section.hasOwnProperty("bd_checker") && section["bd_checker"]
                  ? true
                  : false;
              const isFreelancer = section.hasOwnProperty("isFreelancer")
                ? inwardPartnerState?.includes("payglocal")
                  ? false
                  : !isNotFreelancer === section.isFreelancer
                : true;
              const isXflowInwardOnly = getXflowProduct({ orgDetails })
                ? getXflowProduct({ orgDetails }) === section.inwardXflow
                : isFreelancer;
              const shouldInitialInvoiceRender =
                section?.label === INITIAL_INVOICE ? mode === "view" : true;

              const shouldRender =
                isCompanyTypeAllowed &&
                ((isProductInward && isProductOutward) ||
                  isBothProductSelected) &&
                (isOpsAllowed || isBD_CAllowed) &&
                isXflowInwardOnly &&
                shouldInitialInvoiceRender;
              return (
                shouldRender && (
                  <Tab label={section.label} {...a11yProps(index)} />
                )
              );
            })}
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <BasicInfo handleChange={handleChange} orgDetails={orgDetails} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Box className="products_wrap">
            <Products handleChange={handleChange} orgDetails={orgDetails} />
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          {(inwardPartnerState?.includes("payglocal")
            ? false
            : !isNotFreelancer) || getXflowProduct({ orgDetails }) ? (
            <SoleKyc handleChange={handleChange} orgDetails={orgDetails} />
          ) : (
            <CkycNew handleChange={handleChange} />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          {(inwardPartnerState?.includes("payglocal")
            ? false
            : !isNotFreelancer) || getXflowProduct({ orgDetails }) ? (
            <SoleDocs handleChange={handleChange} />
          ) : (
            <CdocsNew handleChange={handleChange} />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <DirectorDetails
            handleChange={handleChange}
            orgDetails={orgDetails}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
          <Ubo handleChange={handleChange} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={6}>
          <InwardDetails handleChange={handleChange} orgDetails={orgDetails} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={7}>
          <div className="bank_outward">
            <OutwardDetails
              handleChange={handleChange}
              orgDetails={orgDetails}
            />
            <CreateOrg orgId={localStorage.getItem("orgId")} mode={mode} />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={8}>
          <InitialInvoice />
        </CustomTabPanel>
      </Box>

      {isModeView && (
        <div className="fixed_btn_wrap">
          {(!isNotFreelancer || !isNotSoleProp) && hasOnlyXflow ? (
            <Button
              type="primary"
              style={{ marginLeft: "0.5rem" }}
              onClick={handleNextButton}
            >
              {value === 6 ? "Close" : "View Next"}
            </Button>
          ) : (
            <Button
              type="primary"
              style={{ marginLeft: "0.5rem" }}
              htmlType="submit"
              onClick={handleSubmitButton}
            >
              {orgDetails?.isOptInward &&
              orgDetails?.isOptOutward &&
              value === 7
                ? "Close"
                : orgDetails?.isOptInward &&
                  orgDetails?.isOptOutward !== true &&
                  value === 6
                ? "Close"
                : orgDetails?.isOptInward !== true &&
                  orgDetails?.isOptOutward &&
                  value === 7
                ? "Close"
                : "View Next"}
            </Button>
          )}
        </div>
      )}
    </Box>
  );
};

export default OnboardOrgNew;
